import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Receipt } from 'lucide-react';

const PaymentHistorySection = ({ shopId }) => {
  const navigate = useNavigate();

  return (
    <AccordionItem value="payments" className="bg-[#1E293B] border border-[#334155] rounded-lg overflow-hidden">
      <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-[#334155]/30" data-testid="payment-history-trigger">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#EF4444]/20 flex items-center justify-center">
            <Receipt className="w-5 h-5 text-[#F87171]" />
          </div>
          <span className="text-lg font-semibold text-[#E2E8F0]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Payment History
          </span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-6 pb-4">
        <div className="flex flex-col items-center py-6">
          <p className="text-[#94A3B8] mb-4 text-center">
            View complete payment history including all transactions and invoices.
          </p>
          <Button
            onClick={() => navigate(`/shops/${shopId}/payments`)}
            className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white"
            data-testid="view-payment-history-button"
          >
            <Receipt className="w-4 h-4 mr-2" />
            View Payment History
          </Button>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default PaymentHistorySection;
